

<template>
    <div >
        <Breadcrumb class="tablelist-header" v-if="!activeids">
            <BreadcrumbItem>{{title[type]}}异常订单</BreadcrumbItem>
        </Breadcrumb>
        <Steps :current="statusIndex"  class="bg-fff padding-20" v-if="type==='query'">
            <Step  v-for="(val,key) of progressStatus" :title="val.name" :key="key"></Step>
        </Steps>
        <div class="bg-fff padding-bottom-10" v-if="type=='query'">
            <Form inline class="search-other">
                <Button class="margin-right-5 light-content" @click="handleOperate('addnotes')">添加备注</Button>

                <Button class="margin-right-5" type="warning" v-if="dataBaseInfo.errorCode!='unexception'" @click="handleOperate('normal')">恢复正常</Button>

                <Button class="margin-right-5 middle-content" v-if="dataBaseInfo.fulfillmentChannel=='MFN' && (statusIndex==1||statusIndex==2||statusIndex==3||statusIndex==4||statusIndex==5) && SYSID!=1000025" @click="handleOperate('attacheupload')">附件上传</Button>

                <Button class="margin-right-5" type="success" v-if="dataBaseInfo.errorCode=='unexception'&& dataBaseInfo.fulfillmentChannel=='MFN'&&statusIndex!=6" @click="handleOperate('resubmit')">重新提交</Button>

                <Button class="margin-right-5" type="warning" v-if="dataBaseInfo.fulfillmentChannel=='MFN' && (dataBaseInfo.orderStatus=='pending' || dataBaseInfo.orderStatus=='unshipped' || dataBaseInfo.orderStatus=='approved')" @click="handleOperate('edit')">编辑</Button>

                <Button type="primary" class="width-10per pull-right" @click="getDetail()">刷新</Button>
            </Form>
        </div>
        <div v-if="dataBaseInfo.errorCode!='unexception'&&type=='query'&&loading==false" class="errorCodebox ">异常订单:{{dataBaseInfo.errorCode | filterCode()}}</div>
        <!-- 查看 -->
        <compBase :combaseInfo="dataBaseInfo" ref="refbase" class="b2corder"></compBase>
        <!-- 关联 -->
        <compRelation v-if="type=='query'&&dataRelation!=''" :comreleVance="dataRelation" :nodeId="nodeid"></compRelation>
        <!-- 收货 -->
        <compReceive :class="{'b2corder':type=='query'}" v-if="b2cOrderInfo" :alltype="type" :comReceive="dataReceive" ref="refrevice"></compReceive>
        <!-- 产品 -->
        <compProducts :alltype="type" :comProduct="dataProducts" ref="refproduct" :orderOrgId="orderOrgId" :fulfillmentChannel="dataBaseInfo.fulfillmentChannel"></compProducts>
        <!-- 仓库 -->
        <compLogistics :class="{'b2corder':type=='query'}" :alltype="type" :comLogistics="dataLogistics" :orderOrgId="orderOrgId" ref="refwarehouse" ></compLogistics>
        <!-- 包裹 -->
        <compPackages v-if="type=='query'&&dataPackages!=''" :comPackages="dataPackages"></compPackages>
        <!-- 附件 -->
        <compEnclosure v-if="type=='query'&&dataEnclosure!=''" :comEnclosure="dataEnclosure"></compEnclosure>
        <!-- 订单日志 -->
        <compOrderlog v-if="type=='query'" :comOrderlog="dataOrderlog"></compOrderlog>

        <footer class="bg-fff padding-20 text-right" v-if="type!=='query'">
            <Button type="primary" class="width-10per margin-right-10" @click="submit(true)">提交</Button>
            <Button class="width-10per" @click="cancel">取消</Button>
        </footer>

        <!-- 重置订单，项目手动，恢复弹框 -->
        <Modal v-model="operate.show" width="360" :mask-closable='false' @on-cancel="close('all')">
            <div class="headercss">
                <p>{{operate.title}}</p>
            </div>
            <div style="text-align:center;margin-top:15px">
                <p>{{operate.content}}</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" :loading="showDel" long @click="oksubmit">确定</Button>
            </div>
        </Modal>
        <!-- 添加备注、手动回传、附件上传 -->
        <Modal
        class="hidefooter"
        v-model="handle.show"
        :mask-closable='false'
        v-bind="handle"
        >
            <component :is="handle.component" @on-close="handleclose" @on-update="getDetail" v-bind="handle"></component>
            <footer slot="footer" v-show="handle.footer"></footer>
        </Modal>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapState } from 'vuex'
// 各个子组件
import compBase from './base'
import compRelation from './relation'
import compReceive from './receiving'
import compProducts from './products'
import compLogistics from './logistics'
import compPackages from './packages'
import compEnclosure from './enclosure'
import compOrderlog from './orderlog'
// 添加备注、手动回传、附件上传
import comAddnotes from '../alert/addnotes'
import comAttacheupload from '../alert/attachementupload'
// 请求的http
import {
    HttpqueryB2COrder,
    HttpSaveOne,
    HttpResetOrder,
    HttpRecoveryNormal,
    HttpAddRemark,
    HttpResubmit,
} from '@/service/boss/b2corder'
import { constants } from 'os';
export default {
    name: 'comIndex',
    props:['activeids','querytype'],
    components: {
        compBase,
        compRelation,
        compReceive,
        compProducts,
        compLogistics,
        compPackages,
        compEnclosure,
        compOrderlog,
        comAddnotes,

        comAttacheupload,
    },
    data() {
        return {
            SYSID:'',
            showSubmit: false,
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            showDel:false,
            //issuper: this.$route.query.issuper == 1,
            nodeid:0,
            status: '',
            baseData: {},
            title: {
                add: '新增',
                edit: '编辑',
                query: '查看',
            },
            progressStatus: [
                { value: 'pending', name: '未支付' },
                { value: 'unshipped', name: '未发货' },
                { value: 'approved', name: '已审核' },
                { value: 'assigned', name: '已分配' },
                { value: 'picked', name: '已配货' },
                { value: 'shipped', name: '已发货' },
                { value: 'canceled', name: '已取消' }
            ],
            // 几个模块
            orderOrgId:"",
            alldatas:"",
            dataBaseInfo:{},
            dataRelation:[],
            dataReceive:{},
            dataProducts:[],
            dataLogistics:{},
            dataPackages:[],
            dataEnclosure:[],
            dataOrderlog:[],

            operate:{
                // loading:true,
                show:false,
                title:"",
                content:"",
                oktext:'确定',
                canceltext:'取消'
            },

            statusIndex:0,
            // 设置几个弹框的变量
            handle:{
                show:false,
                title:"",
                component: null
            }

        }
    },
    created() {
        this.getDetail()
        this.b2cOrderInfo = this.handleAuth('erp.b2cOrder.address');
    },
    watch:{
        "$route":function(to,from){
            // console.log(to,from)
            // console.log(this.type)
            if(this.type=='query'){
                this.getDetail()
            }
        }
    },
    methods: {
        openloading(){
            // console.log(123123123)
            this.loading = true;
        },
        closeloading(){
            this.loading = false;
        },
        getDetail(){
            if(this.activeids){
                this.id = this.activeids
                this.type = this.querytype
            }else{
                this.id = this.id
                this.type = this.type
            }
            this.loading = true;
            // console.log(this.id)
            return HttpqueryB2COrder({
                orderId: this.id,
            }).then(res => {
                this.handleResponse(res.data);
                this.nodeid = res.data.nodeId
                this.alldatas = res.data
                sessionStorage.set('alldatas', JSON.stringify(res.data))
                this.SYSID = global.SYSID
                this.loading = false;
            }, err => {
                this.loading = false;
                this.errorMessage(err.message);
            });
        },
        handleOperate(val){
            this.operate = {};
            switch(val){
                case 'project':
                    this.operate = {
                        show:true,
                        title:'项目手动关联',
                        content:"确定手动关联项目？请先确认渠道产品已经添加",
                        type:val,
                    }
                break;
                case 'addproduct':
                    const url = this.$router.resolve({
                        path: '/home/b2corder/addgistlist/edit',
                        query: { id: this.id },
                    });
                    window.open(url.href, '_blank');
                break;
                case 'addnotes':
                    this.handle = {
                        title: '添加备注',
                        show:true,
                        activeids:this.id,
                        width:600,
                        component: "comAddnotes",
                    }
                break;
                case 'attacheupload':
                    this.handle = {
                        title: '附件上传',
                        show:true,
                        activeids:this.id,
                        width:1000,
                        component: "comAttacheupload",
                    }
                break;
                case 'normal':
                    this.operate.title = '恢复正常'
                    this.operate = {
                        show:true,
                        title:'恢复正常',
                        content:"确定要将订单恢复为正常处理的订单？",
                        type:val,
                    }
                break;
                case 'removeexcept':
                    this.operate.title = '恢复正常 (仅去除异常)'
                    this.operate = {
                        show:true,
                        title:'恢复正常 (仅去除异常)',
                        content:"该操作仅去除订单的异常类型，不会进入订单自动处理流程",
                        type:val,
                    }
                break;
                case 'resubmit':
                    this.operate = {
                        show:true,
                        title:'重新提交',
                        content: this.$t('global.common.resubmit_desc',{defaultValue:"重新提交后，系统会重新自动处理当前订单"}),
                        type:val,
                    }
                break;
                case 'edit':
                    this.handle = {
                        title: '编辑',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeids:this.id,
                        querytype:'edit'
                    }
                break;
            }
        },
        oksubmit(){
            let request,params = {}, { type } = this.operate
            let orderIds = [];
            orderIds.push(this.id);
            switch(type){
                case 'reset':
                    request = HttpResetOrder;
                    params = { orderIds }
                break;
                case 'project':
                    // request = HttpRecoveryNormal;
                    // params = { id }
                break;
                case 'normal':
                    request = HttpRecoveryNormal;
                    params = { orderIds:orderIds,recoveryNormal:1 }
                break;
                case 'removeexcept':
                    request = HttpRecoveryNormal;
                    params = { orderIds:orderIds,recoveryNormal:0 }
                break;
                case 'resubmit':
                    request = HttpResubmit;
                    params = { orderIds}
                break;
            }
            this.showDel = true
            request(params).then(res => {
                this.operate.show = false
                this.$Message.success(res.message);
                // this.$router.push({
                //     name: "b2cOrder"
                // })
                // 重新进行请求
                this.getDetail()
                this.showDel = false
            }).catch(err=>{
                this.errorMessage(err.message);
                this.showDel = false
            })
        },
        close(val){
            this.$emit('on-openCloseable');
            switch(val){
                case 'all':
                    this.operate.show = false
                break;
            }
            // this.$emit('on-close')
        },
        handleclose(){
            this.$emit('on-openCloseable');
            this.handle = {}
        },
        handleResponse(data){
            // 模块的赋值
            this.orderOrgId = data.contextId;
            //this.$set(this.$data, 'orderOrgId', data.contextId || {});
            this.$set(this.$data, 'dataBaseInfo', data.baseInfo || {});
            this.$set(this.$data, 'dataRelation', data.relation || []);
            this.$set(this.$data, 'dataReceive', data.receive || {});
            this.$set(this.$data, 'dataProducts', data.products || []);
            this.$set(this.$data, 'dataLogistics', data.logistics || {});
            this.$set(this.$data, 'dataPackages', data.packages || []);
            this.$set(this.$data, 'dataEnclosure', data.enclosure || []);
            this.$set(this.$data, 'dataOrderlog', data.orderLog || []);
            // console.log("--------------")
            // console.log(this.orderOrgId )
            // console.log("--------------")
            const orderStatus = data.relation.orderStatus;
            let status = data.baseInfo.orderStatus;
            this.statusIndex = this.progressStatus.findIndex((item) => {
                return item.value === status
            })
            if (orderStatus === 'refunded') {
                this.progressStatus = [
                    { value: 'refunded', name: '已退款' },
                ]
            } else if (orderStatus === 'canceled') {
                this.progressStatus = [
                    { value: 'canceled', name: '已取消' },
                ]
            }
        },
        submit(){
            let refbase = this.$refs.refbase
            let refrevice = this.$refs.refrevice
            let refproduct = this.$refs.refproduct
            let refwarehouse = this.$refs.refwarehouse
            let flag = false;
            // console.log(refrevice.formData)
            for(var key in refrevice.formData){
                if(refrevice.formData['addressline']=='' || refrevice.formData['city']=='' || refrevice.formData['countryCode']=='' || refrevice.formData['postalCode']=='' || !refrevice.formData['shippingName']){
                    flag = true
                };

            }
            for(var key in refwarehouse.formData){
                if(!refwarehouse.formData['orgWarehouseCode'] || !refwarehouse.formData['shippingMethodCode']){
                    flag = true
                };
            }

            if(flag){
                this.$Message.error('带*的数值不能为空');
            }else{

                this.loading = true
                HttpSaveOne({
                    baseInfo:refbase.combaseInfo,
                    receive:refrevice.formData,
                    products:refproduct.comProduct,
                    logistics:refwarehouse.formData
                }).then( res=>{
                    this.$Message.success(res.message);

                    if(this.querytype == 'edit'){
                        this.$emit('on-update')
                        this.$emit('on-close')
                    }else{
                        this.type = 'query'
                        this.$router.push({
                            // name: "b2cOrder"
                            name: 'errorderUpdate',
                            params: { type: "query" },
                            query: { id: this.id },
                        })
                    }
                }, err => {
                    this.errorMessage(err.message);
                }).finally(() => {
                this.loading = false;
            })
            }
        },
        cancel(){
            if(this.querytype == 'edit'){
                this.$emit('on-close')
            }else{
                this.$router.push({
                    name: "errorderList"
                })
            }
        }
    },
    filters:{
        filterCode(val){
            let errorcode;
            switch (val) {
                case 'unexception': errorcode = '无异常的订单'; break;
                case 'systemException': errorcode = '系统异常'; break;
                case 'produceException': errorcode = '商品无法关联'; break;
                case 'addressException': errorcode = '订单地址异常'; break;
                case 'updateException': errorcode = '订单更新异常'; break;
                case 'pickingException': errorcode = '订单配货异常'; break;
                case 'cancelException': errorcode = '订单取消异常'; break;
                case 'trackingException': errorcode = 'Tracking异常'; break;
                case 'costException': errorcode = '订单成本异常'; break;
                case 'carrierException': errorcode = '订单发运方式异常'; break;
                case 'uploadException': errorcode = '订单附件上传异常'; break;
            }
            return errorcode
        }
    },
    beforeDestroy() {

    }
}
</script>
